import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpStatus } from '@core/http-status';
import { ErrorResponse } from '@root/api/models';
import { RouteEntity } from '@core/router/router.entity';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';


/**
 * Service "interceptor" errors in requests to the server
 */
@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    readonly #router: Router = inject(Router);

    /**
     * analyzes the request to the server,
     * logout if the response code is 401
     * @param request - request
     * @param next - request handler
     */
    public intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<ErrorResponse>> {
        return next.handle(request).pipe(
            tap(
                () => {
                },
                (err: HttpErrorResponse) => {
                    if (err instanceof HttpErrorResponse && !request.url.includes('logout')) {
                        if (err.status === HttpStatus.Unauthorized) {
                            this.#router.navigate([RouteEntity.Root, RouteEntity.Logout]);
                        } else if (err.status === HttpStatus.NotFound) {
                            Object.assign(err, { error: { errorUserMessage: 'Not found' } });
                        }
                    }
                },
            ),
        );
    }
}
